/* lua.js generated code 0.3.0 */

/* 
Copyright (c) 2011-2014 chukong-inc.com

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

 */
var Sprite = cc.Sprite
Sprite.prototype.playAnimationOnce = function (animation, args) {
    var self = this
    var actions = table()
    var showDelay = args.showDelay || 0
    if (showDelay) {
        self.setVisible(false)
        actions[$len(actions) + 1] = cc.DelayTime.create(showDelay)
        actions[$len(actions) + 1] = cc.Show.create()
    }
    var delay = args.delay || 0
    if (delay > 0) {
        actions[$len(actions) + 1] = cc.DelayTime.create(delay)
    }
    actions[$len(actions) + 1] = cc.Animate.create(animation)
    if (args.removeSelf) {
        actions[$len(actions) + 1] = cc.RemoveSelf.create()
    }
    if (onComplete) {
        actions[$len(actions) + 1] = cc.CallFunc.create(onComplete)
    }
    var action
    if ($len(actions) > 1) {
        action = cc.Sequence.create(actions)
    } else {
        action = actions[1]
    }
    self.runAction(action)
    return action
}
Sprite.prototype.playAnimationForever = function (animation) {
    var self = this
    var animate = cc.Animate.create(animation)
    var action = cc.RepeatForever.create(animate)
    self.runAction(action)
    return action
}
Sprite.prototype.play = function (animate, delay, repeatTimes, onRepeatFinishCallback, removeAfterRepeatFinished) {
    var self = this
    var repeatAction = null
    var context = self
    if (type(repeatTimes) === "number" && repeatTimes > 0) {
        function onRepeatFinished() {
            if (onRepeatFinishCallback) {
                onRepeatFinishCallback()
            }
            if (removeAfterRepeatFinished) {
                context.removeFromParent(true)
            }
        }
        repeatAction = cc.Sequence.create(cc.Repeat.create(animate, repeatTimes), cc.CallFunc.create(onRepeatFinished))
    } else {
        repeatAction = cc.RepeatForever.create(animate)
    }
    if (type(delay) === "number" && delay > 0) {
        self.setVisible(false)
        repeatAction.retain()
        function onDelayTimeFinished() {
            context.setVisible(true)
            context.stopAllActions()
            context.runAction(repeatAction)
            repeatAction.release()
        }
        self.runAction(cc.Sequence.create(cc.DelayTime.create(delay), cc.CallFunc.create(onDelayTimeFinished)))
    } else {
        self.runAction(repeatAction)
    }
    return repeatAction
}
Sprite.prototype.removeChildren = function (cleanup) {
    var self = this
    var isCleanup = true
    if (cleanup != null) {
        isCleanup = cleanup
    }
    self.removeAllChildren(isCleanup)
}
Sprite.prototype.onClicked = function (callback) {
    var self = this
    self.enabled = true
    var ctx = self
    function onTouchesMoved(touch, event) { }
    function onTouchesBegan(touch, event) {
        if (!self.enabled) {
            return false
        }
        var tp = touch.getLocation()
        var s = self.getContentSize()
        var ap = self.getAnchorPoint()
        var position = self.convertToNodeSpace(tp)
        var touchRect = cc.rect(0, 0, s.width, s.height)
        var b = cc.rectContainsPoint(touchRect, position)
        return b
    }
    function onTouchesEnd(touch, event) {
        callback(touch)
    }
    var listener = cc.EventListenerTouchOneByOne.create()
    listener.setSwallowTouches(true)
    listener.registerScriptHandler(onTouchesBegan, cc.Handler.EVENT_TOUCH_BEGAN)
    listener.registerScriptHandler(onTouchesMoved, cc.Handler.EVENT_TOUCH_MOVED)
    listener.registerScriptHandler(onTouchesEnd, cc.Handler.EVENT_TOUCH_ENDED)
    cc.eventManager.addListener(listener, self)
    // var eventDispatcher = self.getEventDispatcher()
    // eventDispatcher.addEventListenerWithSceneGraphPriority(listener, self)
    return self
}
Sprite.prototype.setEnable = function (enabled) {
    var self = this
    self.enabled = enabled
}
Sprite.prototype.isEnabled = function () {
    var self = this
    return self.enabled
}
